export default function OutcomesSection() {
    return <section className="mz-section mz-outcomes mz-section--soft">
        <div className="mz-container">
            <p className="mz-section-label">Career Readiness</p>
            <h2 className="mz-section-title">Build a profile that goes beyond academic marks.</h2>
            <p className="mz-section-lead">MockZo helps students strengthen the areas employers actually evaluate during the hiring process — not just what appears on a marksheet.</p>
            <div className="mz-metrics">
                {[
                    ['Skills', 'Build practical knowledge you can apply, explain, and demonstrate.'],
                    ['Projects', 'Gain hands-on experience by working on meaningful, real-world assignments.'],
                    ['Feedback', 'Understand your strengths, identify gaps, and know exactly where to improve.'],
                    ['Readiness', 'Practice how you communicate, present your work, and perform in interviews.'],
                ].map(([value, description]) => <div key={value}><strong>{value}</strong><span>{description}</span></div>)}
            </div>
            <p className="mz-outcomes__closing">Together, these experiences help you build a stronger profile, speak with more confidence, and approach opportunities better prepared.</p>
        </div>
    </section>;
}
